import { render, staticRenderFns } from "./ResultsPanel.vue?vue&type=template&id=07c804f2&scoped=true&"
import script from "./ResultsPanel.vue?vue&type=script&lang=js&"
export * from "./ResultsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ResultsPanel.vue?vue&type=style&index=0&id=07c804f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c804f2",
  null
  
)

export default component.exports